export default __webpack_public_path__ + "static/media/error.ce1298d3.svg";